<fgb-banner [pageTitle]="'bulls.pay.page.title' | translate" />

<fgb-page-header [pageTitle]="'bulls.pay.page.title'" [backButtonLink]="'/'"></fgb-page-header>

<div class="d-block d-lg-none">
  <div class="container">
    <ul class="payment-nav ps-0">
      <a class="nav-item" [routerLink]="['/ecash']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
        <label>{{ 'nav.card' | translate }}</label>
      </a>
      <a
        class="nav-item"
        [routerLink]="['/ecashhistory']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <label>{{ 'nav.ecash.history' | translate }}</label>
      </a>
    </ul>
  </div>
</div>

<div class="container">
  <div class="d-none d-lg-block">
    <fgbcl-ecash-description></fgbcl-ecash-description>
  </div>

  <fgbcl-card-token-list
    [regex]="regex"
    [provider]="provider"
    [redirectUrl]="'/cardtoken/success'"
    [failureUrl]="'/cardtoken/failure'"
    [showExpiry]="false"
    [cardIssuerProvider]="'payment.provider.name' | translate"
  ></fgbcl-card-token-list>

  <div class="d-block d-lg-none">
    <fgbcl-ecash-description></fgbcl-ecash-description>
  </div>

  <div class="mt-4 mb-5 d-lg-block d-none">
    <h2 class="mb-2">{{ 'transaction.history.title' | translate }}</h2>
    <fgb-transaction-history [transactionTypes]="[transactionTypes.payment]" [ecashView]="true"></fgb-transaction-history>
  </div>
</div>
